import axios from "axios";

import { devMode } from "./base";
const baseDomain = `https://m-car${devMode ? "-dev" : ""}.mioto.vn`;
const commonDomain = `https://m-common${devMode ? "-dev" : ""}.mioto.vn`;

const map4DKeyApi = "847bd3a139a982d07c03ba07e4ca443c";

export function getLandingPage() {
	return axios({
		withCredentials: true,
		method: "GET",
		url: `${baseDomain}/landingpage`,
	});
}
export function getHomePage(lat, lon, st, et) {
	const mLat = lat ? `lat=${lat}` : "";
	const mLon = lon ? `&lon=${lon}` : "";
	const mSt = st ? `&st=${st}` : "";
	const mEt = et ? `&et=${et}` : "";

	return axios({
		withCredentials: true,
		method: "GET",
		url: `${baseDomain}/homepage/all?${mLat}${mLon}${mSt}${mEt}`,
	});
}

export function getCity(city) {
	return axios({
		withCredentials: true,
		method: "GET",
		url: `${baseDomain}/city/detail/sd?city=${city}`,
	});
}
export function getCityWithDriver(city) {
	return axios({
		withCredentials: true,
		method: "GET",
		url: `${baseDomain}/city/detail/wd?city=${city}`,
	});
}

export function submitFormOwnerRegister(data) {
	return axios({
		withCredentials: true,
		method: "POST",
		url: `${commonDomain}/owner/register?name=${data.name}&phoneNumber=${data.phoneNumber}&city=${data.city}&email=${data.email}&isRental=${data.isRental}&reference=${data.reference}&carName=${data.carName}&stype=${data.stype}`,
	});
}

export function submitFormBizRegister(data) {
	const website = data.website ? `&website=${data.website}` : "";
	const etpName = data.etpName ? `&etpName=${data.etpName}` : "";
	const etpSize = data.etpSize ? `&etpSize=${data.etpSize}` : "";
	// const etpDivision = data.etpDivision ? `&etpDivision=${data.etpDivision}` : "";
	// const etpRoll = data.etpRoll ? `&etpRoll=${data.etpRoll}` : "";
	const etpTripAmount = data.etpTripAmount ? `&etpTripAmount=${data.etpTripAmount}` : "";
	const etpBusinessModel = data.etpBusinessModel ? `&etpBusinessModel=${data.etpBusinessModel}` : "";
	const ptBusinessModel = data.ptBusinessModel ? `&ptBusinessModel=${data.ptBusinessModel}` : "";

	return axios({
		method: "POST",
		url: `${commonDomain}/biz/register?name=${data.name}&phoneNumber=${data.phoneNumber}&registerType=${data.registerType}&city=${data.city}&email=${data.email}${website}${etpName}${etpSize}${etpBusinessModel}${etpTripAmount}${ptBusinessModel}`,
	});
}

export function getListGroupsFAQ(type) {
	return axios({
		withCredentials: true,
		method: "GET",
		url: `${commonDomain}/faqs/group?type=${type}`,
	});
}

export function getListPostsInGroupFAQ(groupId) {
	return axios({
		withCredentials: true,
		method: "GET",
		url: `${commonDomain}/faqs/post?group=${groupId}`,
	});
}

export function getAllCity() {
	return axios({
		withCredentials: true,
		method: "GET",
		url: `${commonDomain}/address/all-cities`,
	});
}

export function getAllDistrictOfCity(city) {
	return axios({
		withCredentials: true,
		method: "GET",
		url: `${commonDomain}/address/districts-by-city?city=${city}`,
	});
}

export function getAllWardOfDistrict(district) {
	return axios({
		withCredentials: true,
		method: "GET",
		url: `${commonDomain}/address/wards-by-district?district=${district}`,
	});
}

export function searchLocations(stype, query) {
	const pQuery = query && query !== "" ? `&query=${query}` : "";

	return axios({
		withCredentials: true,
		method: "GET",
		url: `${baseDomain}/car/search-locations?stype=${stype}${pQuery}`,
	});
}

export function getRouteMap4D(origin, destination, points) {
	return axios({
		method: "GET",
		url: `https://api.map4d.vn/sdk/route?key=${map4DKeyApi}&mode=car&origin=${origin}&destination=${destination}&points=${points}`,
	});
}

export function searchInHouse(query, lat, lon) {
	// "lat": lat, "lon": lon
	const address = query && query !== "" ? `&address=${query}` : "";
	const pLat = lat ? `&lat=${lat}` : "";
	const pLon = lon ? `&lon=${lon}` : "";

	return axios({
		withCredentials: true,
		method: "GET",
		url: `${commonDomain}/lbs/search-address?sdkMap=2${address}${pLat}${pLon}`,
	});
}

//MAP4D: Reserve Geocoding
export function getAddressFromLatLng(lat, lng) {
	const location = `${lat},${lng}`;

	return axios({
		method: "GET",
		url: `https://api.map4d.vn/sdk/v2/geocode?key=${map4DKeyApi}&location=${location}`,
	});
}

//Here: Reserve Geocoding
export async function getAddressFromLatLngHere(lat, lng) {
	const apikey = "jlQhrU7SzPSOHM-CLMVJ_RgTN2K3ifYmhVPp4XRaBnc";
	const lang = "vi-VN";

	return await axios({
		method: "GET",
		withCredentials: true,
		url: `https://revgeocode.search.hereapi.com/v1/revgeocode?at=${lat}%2C${lng}&lang=${lang}&apikey=${apikey}`,
	});
}

//Data to sign contract
export function requestToSignContract(data) {
	const forSelfDrive = data.forSelfDrive ? `forSelfDrive=${data.forSelfDrive}` : "";
	const forWithDriver = data.forWithDriver ? `&forWithDriver=${data.forWithDriver}` : "";
	const ownerFullname = data.ownerFullname ? `&ownerFullname=${data.ownerFullname}` : "";
	const ownerCmnd = data.ownerCmnd ? `&ownerCmnd=${data.ownerCmnd}` : "";
	const ownerCmndIssuedDate = data.ownerCmndIssuedDate ? `&ownerCmndIssuedDate=${data.ownerCmndIssuedDate}` : "";
	const ownerCmndIssuedPlace = data.ownerCmndIssuedPlace ? `&ownerCmndIssuedPlace=${data.ownerCmndIssuedPlace}` : "";
	const ownerTaxCode = data.ownerTaxCode ? `&ownerTaxCode=${data.ownerTaxCode}` : "";
	const ownerTaxIssuedDate = data.ownerTaxIssuedDate ? `&ownerTaxIssuedDate=${data.ownerTaxIssuedDate}` : "";
	const ownerTaxIssuedPlace = data.ownerTaxIssuedPlace ? `&ownerTaxIssuedPlace=${data.ownerTaxIssuedPlace}` : "";
	const address = data.address ? `&address=${data.address}` : "";
	const email = data.email ? `&email=${data.email}` : "";
	const phoneNumber = data.phoneNumber ? `&phoneNumber=${data.phoneNumber}` : "";

	return axios({
		method: "POST",
		withCredentials: true,
		url: `${commonDomain}/contract/request-to-sign-contract?${forSelfDrive}${forWithDriver}${ownerFullname}${ownerCmnd}${ownerCmndIssuedDate}${ownerCmndIssuedPlace}${ownerTaxCode}${ownerTaxIssuedDate}${ownerTaxIssuedPlace}${address}${email}${phoneNumber}`,
	});
}

export function checkOwnerContract() {
	return axios({
		method: "GET",
		withCredentials: true,
		url: `${commonDomain}/contract/check-owner`,
	});
}
